import { Button as AntButton, Modal, Table, TableColumnsType } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getDownloadHistories } from "../../../api/archives.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import { IDownloadHistory, IGetDownloadHistories } from "../../../models/archives.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  archiveGbn: string;
  archiveCode: number;
}

const DownloadHistoryModal: FC<IProps> = ({
  visible, setVisible, archiveGbn, archiveCode,
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetDownloadHistories>();

  const [page, setPage] = useState(1);

  useEffect(() => {
    if (auth?.hqYn === 'N') {
      setVisible(false);
    }
  }, [auth]);

  useEffect(() => {
    if (archiveGbn && archiveCode) {
      execute(getDownloadHistories(archiveGbn, archiveCode));
    }
  }, [archiveGbn, archiveCode]);

  const columns: TableColumnsType<IDownloadHistory> = [
    {
      title: t('archive.exam.column1'),
      dataIndex: 'logCode',
      key: 'logCode',
      align: 'center',
      sorter: (a, b) => a.logCode - b.logCode,
    },
    {
      title: t('archive.exam.column8'),
      dataIndex: 'userFileName',
      key: 'userFileName',
      align: 'center',
      sorter: (a, b) => a.userFileName?.localeCompare(b.userFileName),
    },
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
      sorter: (a, b) => a.campusKorName?.localeCompare(b.campusKorName),
    },
    {
      title: t('archive.exam.column9'),
      key: 'regMemKorName',
      dataIndex: 'regMemKorName',
      align: 'center',
      sorter: (a, b) => a.regMemKorName?.localeCompare(b.regMemKorName),
    },
    {
      title: t('archive.exam.column10'),
      key: 'regDate',
      dataIndex: 'regDate',
      align: 'center',
      sorter: (a, b) => a.regDate?.localeCompare(b.regDate),
      render: value => moment(value).format('YYYY.MM.DD')
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('archive.exam.button1')}
        width={750}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className="comm-bx__space">
          <div className="comm-sch_result">
          {t('archive.exam.text1')}: <b>{res?.data?.length || 0}</b>
          </div>
        </div>
        <div className='comm-table__area mt-0'>
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: page,
              pageSize: config.miniPageSize
            }}
          />
        </div>
        <div className="comm-bx__between">
          <div className="common-paging center">
            <Pagination
              count={res?.data?.length || 0}
              page={page}
              setPage={setPage}
              mini
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default DownloadHistoryModal;
